export default __webpack_public_path__ + "static/5p_1-93ff5da20521ee586d4b790864cda8b4.png";